import React from "react";
import ReactDOM from "react-dom/client"; // შეიცვალა იმპორტი

import { createStore, applyMiddleware, compose } from "redux";

import { Provider } from "react-redux";
import ReduxThunk from "redux-thunk";

import reducers from "./reducers";
import router from "./router";

import { RouterProvider } from "react-router-dom";
import "./i18n";

import SkeletonLoader from "./components/SkeletonLoader";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(ReduxThunk)),
);

// ვქმნით root-ს createRoot მეთოდით
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.Suspense fallback={<SkeletonLoader />}>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.Suspense>,
);

// Register service worker for PWA installability
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
